/**
 * @generated SignedSource<<b0ff32de601d6e41ab16ab1437311f83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutTransactionQueryRenderer_buyer$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutLayout_buyer" | "checkoutSetUpActions_buyer">;
  readonly " $fragmentType": "CheckoutTransactionQueryRenderer_buyer";
};
export type CheckoutTransactionQueryRenderer_buyer$key = {
  readonly " $data"?: CheckoutTransactionQueryRenderer_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTransactionQueryRenderer_buyer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutTransactionQueryRenderer_buyer",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutLayout_buyer"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutSetUpActions_buyer",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutUIActionsTransactionSetup_buyer",
          "selections": [
            {
              "kind": "InlineDataFragmentSpread",
              "name": "checkoutUIReducer_buyer",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasSupportedChargeCurrency",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserPreferences",
                  "kind": "LinkedField",
                  "name": "preferences",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "currency",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "checkoutTrackingActions_buyer",
          "selections": [
            (v0/*: any*/)
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "alias": "isVerifiedTrade",
          "args": [
            {
              "kind": "Literal",
              "name": "name",
              "value": "B_NET_PRICE"
            }
          ],
          "kind": "ScalarField",
          "name": "hasPermission",
          "storageKey": "hasPermission(name:\"B_NET_PRICE\")"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "f0db92f2ad2a277a07d9c66867794874";

export default node;
